/* EN-4396: the orders service reads the active scope from module state, so it
   must match the sidebar on every page. A page without the account level
   reads one division, whatever the sidebar says: leaving /app/orders at the
   account level would otherwise keep sending scope=account from, say, the
   dashboard while the notice says one division. A supported page follows the
   account view even when it never calls useActiveOrdersScope itself (the
   Shipped and Returns lists, F1061), so a switcher pick there is not left at
   the level the last orders page set. Following twice in one render (here and
   in the page) is safe: the level only moves when level or filter change.
   Called above <Outlet/>, so the page's queries key on the right level in the
   same render. */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useSearchParams } from 'react-router';
import { DIVISION_FILTER_PARAM } from './scope';
import { NO_DIVISIONS, followAccountView, settleActiveScope } from './active';
import { supportsAccountLevel } from './pages';
import { useAccountView } from './useAccountView';

export function useDivisionLevelOffAccountPages() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { view, level } = useAccountView();
  const client = useQueryClient();

  if (!supportsAccountLevel(pathname)) {
    followAccountView('division', NO_DIVISIONS, null);
  } else {
    followAccountView(
      level,
      view.available ? view.divisions : NO_DIVISIONS,
      searchParams.get(DIVISION_FILTER_PARAM),
    );
  }
  useEffect(() => settleActiveScope(client));
}
